export default __webpack_public_path__ + "static/media/placeholder-home (2).c5fdff17.png";